import Model from 'src/storage/base';
import { validateObj } from 'src/helpers';
import AlertManager from 'src/components/alert';
import LANG_CONST from 'src/helpers/lang/const';
import constants from 'src/constants';

class SettingTreatmentsModel extends Model {
  id = 'SettingTreatmentsModel';
  defaultState = () => ({});
  persistent = false;
  apiConfig = {
    update: {
      url: 'profile/set/treatments',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onHandleChangeProfile = (profile) => {
    const treatments = JSON.parse(JSON.stringify(profile.treatments || []));
    this.setState({
      user: profile,
      treatments
    });
  };

  saveData = ({ id, name, description, fee, media, files }) => {
    return new Promise((resolve) => {
      const req = {
        id: id || Date.now(),
        name,
        description,
        fee,
        media
      };

      let invalid = validateObj(req, {
        name: 'required',
        description: 'required',
        fee: 'treatmentFee'
      });

      if (invalid.length === 0) {
        let value = [...this.state.treatments];
        if (id) {
          value = value.map((item) => {
            if (item.id === id) {
              return req;
            }
            return item;
          });
        } else {
          value.unshift(req);
        }
        this.api('update', { [req.id]: files, value }, (err, data, success) => {
          resolve({
            ok: !err && success,
            data
          });
        });
      } else {
        resolve({
          ok: false,
          invalid
        });
      }
    });
  };

  del = (id) => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          this.api(
            'update',
            { value: this.state.treatments.filter((item) => item.id !== id) },
            () => {
              actions.hide();
              actions.setLoading(false);
            }
          );
        }
      }
    });
  };

  getCurrency = () => {
    return this.state.user?.currency || constants.general.defaultCurrency;
  };
}

const model = new SettingTreatmentsModel();
export default model;
